import React, { FC } from 'react';
import styled, { css } from 'styled-components';
import { colors, shadows } from 'src/config/colors';
import { Button } from 'src/common/components/Button';
import { typography } from 'src/config/typography';
import YouTubeIcon from 'src/assets/icons/YouTubeIcon';
import { below, media, widthBreakpoints } from 'src/config/breakpoints';
import { useMediaQuery } from 'src/common/migration/useMediaQuery';
import { youtubeChannel } from 'src/config/globals';

const Box = styled.div<{ leftPanel?: boolean; mobileOnly?: boolean }>`
  border-radius: 0.375rem;
  box-shadow: ${shadows.drop1};
  background: ${colors.grey08};
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 2.125rem 3.3125rem 3rem;
  ${media.w.min.px576(css`
    padding: 2.625rem 0.75rem 2rem;
  `)}

  ${media.w.min.px992(css`
    display: none;
  `)}

  ${({ leftPanel }) =>
    leftPanel &&
    css`
      ${media.w.min.px576(css`
        display: flex;
        padding: 3.0625rem 0.8125rem 3.75rem;
      `)}
    `}

  ${({ mobileOnly }) =>
    mobileOnly &&
    css`
      ${media.w.min.px576(css`
        display: none;
      `)}
    `}
`;

const Text = styled.div`
  font-family: ${typography.fontFamilyDefault};
  font-size: 0.75rem;
  line-height: 1rem;
  text-align: center;
  margin-bottom: 1.25rem;
  max-width: 14.1875rem;

  ${media.w.min.px576(css`
    max-width: max-content;
  `)}
`;

const StyledYoutubeIcon = styled(YouTubeIcon)`
  margin-bottom: 0.625rem;
  color: ${colors.redBright};
`;

interface YoutubeCardProps {
  leftPanel?: boolean;
  mobileOnly?: boolean;
}

export const SpeakerListingYoutubeCard: FC<YoutubeCardProps> = ({ leftPanel, mobileOnly }) => {
  const isMobile = useMediaQuery({ maxWidth: below(widthBreakpoints.px576) });

  return (
    <Box mobileOnly={mobileOnly} leftPanel={leftPanel}>
      <StyledYoutubeIcon size={isMobile ? 100 : 64} />

      <Text>
        Na profilu wykładowcy sprawdzisz jego nadchodzące szkolenia oraz opublikowane artykuły.
        <br />
        <br />
        Chcesz uzupełnić wiedzę o podcasty?
      </Text>
      <Button as="a" kind="primary" href={youtubeChannel} target="_blank">
        Sprawdź nas na YouTube
      </Button>
    </Box>
  );
};
